import React, { useState } from "react";

// A list of short values: type and press Enter or comma to add, click × to remove.
function TagInput({ id, value, onChange, placeholder, max = 20 }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const items = raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (items.length === 0) return;
    const next = [...value];
    items.forEach((item) => {
      if (next.length < max && !next.some((v) => v.toLowerCase() === item.toLowerCase())) next.push(item);
    });
    onChange(next);
    setDraft("");
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className="tag-input form-control" onClick={() => document.getElementById(id)?.focus()}>
      {value.map((item) => (
        <span key={item} className="tag tag-removable">
          {item}
          <button
            type="button"
            aria-label={`Remove ${item}`}
            onClick={(e) => {
              e.stopPropagation();
              onChange(value.filter((v) => v !== item));
            }}
          >
            <i className="bi bi-x" />
          </button>
        </span>
      ))}
      <input
        id={id}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => add(draft)}
        placeholder={value.length ? "" : placeholder}
        disabled={value.length >= max}
      />
    </div>
  );
}

export default TagInput;
